import {
  GAME_ID,
  SELECT_LEVEL,
  INIT_STANDARD_ROUND,
  NEXT_STANDARD_QUESTION,
  COMPLETE_STANDARD_ROUND,
  INTERRUPT_STANDARD_ROUND,
  MARK_PROGRESS,
  STANDARD_ROUND_STATUSES,
  RESET_ROUND_STATUS,
  UPDATE_RECORDS,
} from '../data/goblinGourmetConstants';

const initialState = {
  // level id round belongs to
  levelId: null,
  // list of question ids
  questionIdsInRound: [],
  // current question index
  questionIndex: null,
  // user's progress
  progress: 0,
  // status of current round, can be STARTED, INTERRUPTED or COMPLETED
  status: null,
  // true, if user already seen instruction page in this round
  isInstructionCompleted: false,
  // true if started level with saved data
  didLoadSavedData: false,
  // retain data on intermediate save for Embedded Measurement Records array
  records: [],
};

const goblinGourmetStandardRoundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case SELECT_LEVEL: {
      const { levelId } = action.payload;

      return {
        ...state,
        levelId,
      };
    }
    case INIT_STANDARD_ROUND: {
      const { levelId, questionIdsInRound, progress, questionIndex, records, didLoadSavedData } = action.payload;
      return {
        ...initialState,
        levelId,
        progress,
        questionIndex: questionIndex === undefined ? 0 : questionIndex,
        questionIdsInRound,
        status: STANDARD_ROUND_STATUSES.STARTED,
        isInstructionCompleted: false,
        records,
        didLoadSavedData,
      };
    }
    case NEXT_STANDARD_QUESTION: {
      const { isInstructionCompleted } = action.payload;

      return {
        ...state,
        questionIndex: state.questionIndex + 1,
        isInstructionCompleted,
      };
    }
    case COMPLETE_STANDARD_ROUND: {
      return {
        ...state,
        questionIndex: null,
        status: STANDARD_ROUND_STATUSES.COMPLETED,
      };
    }
    case INTERRUPT_STANDARD_ROUND: {
      return {
        ...state,
        status: STANDARD_ROUND_STATUSES.INTERRUPTED,
      };
    }
    case RESET_ROUND_STATUS: {
      return {
        ...state,
        status: null,
        records: [],
      };
    }
    case MARK_PROGRESS: {
      const { progressIncrement } = action.payload;

      return {
        ...state,
        progress: state.progress + progressIncrement,
      };
    }
    case UPDATE_RECORDS: {
      const { currentRecord } = action.payload;
      return {
        ...state,
        records: [...state.records, currentRecord],
      };
    }
    default:
      return state;
  }
};

export default goblinGourmetStandardRoundReducer;
